export const SET_APP_VERSION_CHECKED = 'SET_APP_VERSION_CHECKED';
export const SET_APP_OUT_OF_DATE = 'SET_APP_OUT_OF_DATE'